var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main"},_vm._l((_vm.$store.state.contact_page.sections),function(section){return _c('section-component',{key:section.id,attrs:{"id":section.id,"text":section.text,"icons":section.icons}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }